<div class="agreement-page-container">
  <div class="page-top-section">
    <a routerLink="/" class="back-to-home-link">← Back to Home</a>
    <img src="assets/images/logo/Dashboardly-logo.svg" alt="Dashboardly" class="centered-logo" />
  </div>

  <div class="agreement-page-header">
    <div class="agreement-page-title">
      <h1>Seller Agreement</h1>
      <p class="effective-date">Effective Date: {{ effectiveDate }}</p>
    </div>
    <div class="agreement-page-actions">
      <button class="btn-print" (click)="printAgreement()">
        <i class="fa fa-print"></i>
        Print
      </button>
    </div>
  </div>

  <div class="agreement-page-content">
    <div class="agreement-main-content">
      <p class="intro-text">
        This Seller Agreement ("Agreement") governs your access to and use of Dashboardly Inc.'s TikTok e-commerce
        seller dashboard (the "Platform") to sell products and services. By registering as a seller and using the
        Platform, you agree to comply with all terms outlined in this Agreement, as well as our Terms of Service and
        Privacy Policy.
      </p>

      <p class="intro-text">
        If you do not agree to this Agreement, you must immediately discontinue use of the Platform as a seller.
      </p>

      <div class="agreement-section">
        <h2>1. INTRODUCTION</h2>
        <p>
          This Seller Agreement ("Agreement") governs your access to and use of Dashboardly Inc.'s TikTok e-commerce
          seller dashboard (the "Platform") to sell products and services. By registering as a seller and using the
          Platform, you agree to comply with all terms outlined in this Agreement, as well as our Terms of Service and
          Privacy Policy.
        </p>
        <p>If you do not agree to this Agreement, you must immediately discontinue use of the Platform as a seller.</p>
      </div>

      <div class="agreement-section">
        <h2>2. SELLER ELIGIBILITY</h2>
        <p>To be eligible to use the Platform as a seller, you must:</p>
        <ul>
          <li>Be at least 18 years old or have reached the age of majority in your jurisdiction.</li>
          <li>
            Operate as a legal entity, business, or sole proprietor with all necessary business licenses, permits, and
            tax registrations required by law.
          </li>
          <li>
            Ensure that your business complies with all local, national, and international e-commerce regulations.
          </li>
        </ul>
      </div>

      <div class="agreement-section">
        <h2>3. PRODUCT LISTINGS</h2>
        <h3>3.1 Accuracy of Listings</h3>
        <ul>
          <li>
            All product descriptions, prices, images, and specifications must be accurate, truthful, and comply with
            applicable consumer protection laws.
          </li>
          <li>
            Misleading or deceptive listings are strictly prohibited and may result in account suspension or legal
            action.
          </li>
        </ul>

        <h3>3.2 Prohibited Items</h3>
        <p>Sellers may not list, sell, or distribute:</p>
        <ul>
          <li>Counterfeit, replica, or trademark-infringing products.</li>
          <li>Hazardous materials, illegal goods, or restricted products under local or international laws.</li>
          <li>Any items prohibited under TikTok Shop or Platform policies.</li>
        </ul>

        <h3>3.3 Inventory Management</h3>
        <ul>
          <li>
            Sellers are responsible for maintaining sufficient inventory levels to fulfill orders in a timely manner.
          </li>
          <li>
            Repeated stock shortages, order cancellations, or fulfillment failures may result in penalties, reduced
            seller visibility, or account suspension.
          </li>
        </ul>
      </div>

      <div class="agreement-section">
        <h2>4. ORDER FULFILLMENT</h2>
        <h3>4.1 Shipping and Processing</h3>
        <ul>
          <li>Sellers must process and ship orders within the timeframes specified in their listings.</li>
          <li>Accurate tracking information must be provided for every order.</li>
        </ul>

        <h3>4.2 Returns and Refunds</h3>
        <ul>
          <li>Sellers must honor the Platform's return and refund policies.</li>
          <li>
            Sellers are required to cooperate in resolving disputes with buyers to maintain customer satisfaction and
            Platform compliance.
          </li>
        </ul>
      </div>

      <div class="agreement-section">
        <h2>5. FEES AND PAYMENTS</h2>
        <h3>5.1 Platform Fees</h3>
        <ul>
          <li>
            Sellers agree to pay all applicable commission fees, service charges, and processing fees as outlined in the
            Platform's Fee Schedule.
          </li>
          <li>Fees are subject to change, and sellers will receive prior notice of updates.</li>
        </ul>

        <h3>5.2 Payouts</h3>
        <ul>
          <li>
            Payments will be processed according to the payout schedule specified in your seller account settings.
          </li>
          <li>
            Sellers must provide accurate and up-to-date banking or payment details to ensure successful payout
            transfers.
          </li>
          <li>
            Dashboardly is not responsible for delays caused by third-party payment processors or incorrect seller
            payment details.
          </li>
        </ul>

        <h3>5.3 Taxes</h3>
        <ul>
          <li>
            Sellers are solely responsible for collecting, reporting, and remitting all applicable taxes related to
            their sales, including VAT, sales tax, or any other government-imposed taxes.
          </li>
          <li>
            Sellers must ensure full compliance with tax obligations in all jurisdictions where they conduct business.
          </li>
        </ul>
      </div>

      <div class="agreement-section contact-section" id="contact">
        <h2>6. CONTACT INFORMATION</h2>
        <p>For questions or concerns regarding these Terms, please contact us at:</p>
        <div class="contact-details">
          <address>
            <div class="company-name">Dashboardly Inc.</div>
            <div class="address-line">800 SE 4TH AVE STE 711</div>
            <div class="address-line">Hallandale Beach, FL 33009</div>
            <div class="contact-line">
              <span>Email:</span>
              <a href="mailto:hello@dashboardly.io">hello&#64;dashboardly.io</a>
            </div>
            <div class="contact-line">
              <span>Phone:</span>
              <a href="tel:+17866363699">+1 (786) 636-3699</a>
            </div>
            <div class="contact-line">
              <span>Website:</span>
              <a href="https://dashboardly.io" target="_blank">https://dashboardly.io</a>
            </div>
          </address>
        </div>
        <p class="terms-agreement">
          By continuing to use the Platform, you acknowledge and agree to comply with these Terms of Service.
        </p>
      </div>
    </div>

    <div class="agreement-sidebar">
      <div class="sidebar-section">
        <h3>Need assistance?</h3>
        <p>Our seller support team is available to help with any questions about this agreement.</p>
        <a (click)="scrollToContact($event); $event.preventDefault()" class="support-link">Contact seller support</a>
      </div>

      <div class="sidebar-section">
        <h3>Related policies</h3>
        <ul class="sidebar-links">
          <li><a href="/terms" target="_blank">Terms of Service</a></li>
          <li><a href="/privacy" target="_blank">Privacy Policy</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
